import {ITechnicWebServiceClient, TagLightDto} from "@resources/resources";
import {Injectable} from "@angular/core";
import {Resolve} from "@angular/router";

@Injectable()
export class TagsResolver implements Resolve<TagLightDto[]> {

  constructor(private technicWebServiceClient: ITechnicWebServiceClient) {
  }

  resolve() {
    return this.technicWebServiceClient.getTags({locale: "\"" + (this.isFr() ? 'fr' : 'en') + "\""});
  }

  private isFr(): boolean {
    return navigator.language == "fr" || navigator.language == "fr-FR";
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-notifications/digicerba-notifications-web/src/angular/cerba/src/app/pages/cerba/pages/alertes/canaux/enregistrement/tags.resolver.ts